export default __webpack_public_path__ + "static/media/vendedores.659c9b46.svg";